import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, X, ArrowRight } from "lucide-react";

const KEY = "velluto_nudge_dismissed";

// Shown until the member has an age and a photo — without them they stay hidden from Discover.
export function ProfileNudgeBanner({ onProfilePage = false }) {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");
  if (!user || user.role === "admin" || hidden) return null;
  const missing = [!user.age && "your age", !user.photo_url && "a photo"].filter(Boolean);
  if (missing.length === 0) return null;
  const dismiss = () => { sessionStorage.setItem(KEY, "1"); setHidden(true); };
  return (
    <div data-testid="profile-nudge-banner" className="mb-8 rounded-2xl border border-gold/40 bg-gold/8 px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-4">
      <span className="w-10 h-10 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center shrink-0"><Sparkles size={16} className="text-gold" /></span>
      <div className="flex-1 min-w-0">
        <p className="text-sm">You're invisible in Discover until you add {missing.join(" and ")}.</p>
        <p className="text-xs text-text-muted mt-0.5">{onProfilePage ? "Fill them in below — it takes a minute." : "Members can't find or admire a profile without them."}</p>
      </div>
      {!onProfilePage && (
        <Link to="/me" data-testid="profile-nudge-cta" className="flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-full bg-gold text-ink text-[10px] uppercase tracking-[0.15em] hover:bg-gold/90 transition-colors">
          Complete profile <ArrowRight size={12} />
        </Link>
      )}
      <button data-testid="profile-nudge-dismiss" onClick={dismiss} aria-label="Dismiss" className="self-start sm:self-center p-1.5 text-text-muted hover:text-text-main"><X size={14} /></button>
    </div>
  );
}
